import { useSortable } from '@dnd-kit/sortable'
import { CSS } from '@dnd-kit/utilities'
import { MdModeEdit } from 'react-icons/md'
import { RxDragHandleDots2 } from 'react-icons/rx'
import { useNavigate } from 'react-router-dom'

interface Link {
  title: string
  link: string
  id: number
}

export const Card = ({ title, link, id }: Link) => {
  const navigate = useNavigate()
  const { attributes, listeners, setNodeRef, transform, transition } =
    useSortable({ id })

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
  }

  const handleRedirect = () => {
    navigate(`/link/?id=${id}`)
  }

  return (
    <div
      className="mt-7 flex h-16 w-full items-center justify-between
    rounded-lg bg-white px-5 py-4 shadow-md"
      style={style}
    >
      <div className="flex items-center gap-4">
        <div
          ref={setNodeRef}
          {...listeners}
          {...attributes}
          onMouseDown={(e) => e.stopPropagation()}
          onTouchStart={(e) => e.stopPropagation()}
        >
          <RxDragHandleDots2 color="#c2c2c2" className="mr-1.5 cursor-grab" />
        </div>
        <div>
          <p className="capitalize">{title}</p>
          <div
            className="max-w-[200px] overflow-hidden overflow-ellipsis
          whitespace-nowrap underline"
          >
            {link}
          </div>
        </div>
      </div>

      <button
        onClick={handleRedirect}
        className="text-[#c2c2c2] hover:text-[#407BFF]"
      >
        <MdModeEdit color="inherit" />
      </button>
    </div>
  )
}
